import { camelizeKeys } from 'humps';
import * as actionTypes from './../constants/actionTypes';
import { normalizeStoneModel } from '../schemas';
import { getApiConfig } from '../utilities';
import { loadingDialog_show } from './A_Popups';
import _ from 'lodash';
import * as actions from '../actions';
import {AccessRights} from '../schemas/accessRightsModel';
import customEvent from "../utilities/customEvent";

export function normalizeStones(result, entities) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      if (!result || !entities.orderedBy || !entities.orderedBy[result]) {
        reject(new Error('No stones received from the server'));
      }

      const orderedBy = linkStoneSupplierStones(entities).orderedBy[result];
      resolve(dispatch({
        type: actionTypes.FETCH_STONES,
        payload: {
          stones: orderedBy.stones.map(id => entities.stones[id]),
          filterGroups: entities.filterGroups
        }
      }));
    });
  };
}

function normalizeMasterStones(result, entities) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      if (!result || !entities.orderedBy || !entities.orderedBy[result]) {
        reject(new Error('No stones received from the server'));
      }

      const orderedBy = linkStoneSupplierStones(entities).orderedBy[result];
      resolve(dispatch({
        type: actionTypes.FETCH_MASTER_STONES,
        payload: {
          stones: orderedBy.stones.map(id => entities.stones[id]),
          filterGroups: entities.filterGroups
        }
      }));
    });
  };
}

function linkStoneSupplierStones(entities) {
  _.each(entities.stones, (ts) => {
    let sssIds = [].concat(ts.stoneSupplierStones);
    let stoneSupplierStones = [];
    _.each(sssIds, (id) => {
      let key = _.findKey(entities.stoneSupplierStones, (sss) => {
        return sss.id === id;
      });
      stoneSupplierStones.push(entities.stoneSupplierStones[key]);
    });
    ts.stoneSupplierStones = stoneSupplierStones;
  });
  return entities;
}

export function updateStoneSupplierStoneStoreValue(stoneIds, field, value) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: actionTypes.STONE_SUPPLIER_STONE_UPDATE_STORE_VALUE,
      payload: {
        stones: stoneIds,
        field,
        value
      }
    })
  };
}

function shouldFetchStones(state) {
  const { stones } = state;
  if (!stones.sentinel) {
    return true;
  } else if (stones.fetching) {
    return false;
  }
  return stones.invalidated;
}

function loadAndFetchStones() {
  return (dispatch, getState) => {
    const {stones, stonesV2} = getState();
    dispatch(actions.requireFabricatorAdmin())
      .then(() => {
        return dispatch(actions.loadingDialog_show(true, 'Loading Stone Data', 'Please wait while we look up your stone data.'))
          .then(() => dispatch(actions.fetchStones()))
          .then(() => dispatch(actions.loadingDialog_show(false)));
      })
      .catch((error) => {
        console.error(error);
        dispatch(actions.loadingDialog_show(false));
      });
  }
}

function fetchStones() {
  return function (dispatch, getState) {
    /*return new Promise((resolve) => {
      let state = getState();
      let AR = AccessRights.get(state);
      const { get, post } = getApiConfig();
      return get('api/Public/' + state.auth.masterFabricatorId + '/AvailableStones?jobId=0&Type=Fabricator&loadStoneFilters=true')
        .then(json => camelizeKeys(json))
        .then(json => normalizeStoneModel(json))
        .then(({result, entities}) => {
          dispatch({
            type: actionTypes.UPDATE_MASTER_ENTITIES,
            payload: {result, entities}
          });
          return dispatch(normalizeMasterStones(result, entities));
        })
        .then(() => {
          get('api/Public/' + state.auth.fabricatorId + '/AvailableStones?jobId=0&type=Fabricator&loadStoneFilters=true&includeDisabled=true')
          .then(json => camelizeKeys(json))
          .then(json => normalizeStoneModel(json))
          .then(({ result, entities }) => {
            dispatch({
              type: actionTypes.UPDATE_ENTITIES,
              payload: { result, entities }
            });
            return dispatch(normalizeStones(result, entities));
          })
          .then((r) => {
            if(AR.isSiteAdmin()) {
              get('api/Dashboard_Stones/GetUserUploadedStones')
              .then(json => camelizeKeys(json))
              .then(json => normalizeStoneModel(json))
              .then(res => {
                resolve(dispatch({
                  type: actionTypes.FETCH_USER_UPLOADED_STONES,
                  payload: {
                    stones: res.entities.orderedBy.root
                  }
                }));
              })
              .then(() => resolve(r));
            } else {
              resolve(r);
            }
          });
        })
    });*/
    const {get} = getApiConfig('Dashboard/');
    const {auth, asCustomer} = getState();
    let fabId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    dispatch({type: actionTypes.STONE_CLEAR});
    document.dispatchEvent(customEvent('stones-loading'));
    return get('GetStonesData?fabricatorId=' + fabId + '&masterFabricatorId=' + auth.masterFabricatorId)
      .then((result) => {
        dispatch({
          type: actionTypes.FETCH_STONES,
          payload: result
        })
      });
  }
}

function fetchStonesFilters() {
  return function (dispatch, getState) {
    const {get} = getApiConfig('Filters/GetStonesFilterGroups');
    dispatch({type: actionTypes.FETCHING_STONES_FILTERS});
    return get()
      .then((result) => {
        dispatch({
          type: actionTypes.FETCHED_STONES_FILTERS,
          payload: result
        })
      });
  }
}

function filterStonesColor(color) {
  if(color === 'ALL') {
    color = '';
  }
  return {
    type: actionTypes.FILTER_STONES_COLOR,
    payload: color.toLowerCase()
  };
}

function filterStonesMaterial(material) {
  if(material === 'ALL') {
    material = '';
  }
  return {
    type: actionTypes.FILTER_STONES_MATERIAL,
    payload: material.toLowerCase()
  };
}

/**
 *
 */
export function addMaterialsFilter(item, type) {
  return (dispatch, getState) => {
    const {search} = getState();
    dispatch(actions.loadingDialog_show(true, 'Filtering...', 'Filtering Stones, this will just take a moment'))
    .then(() => {
      return dispatch({
        type: actionTypes.SET_FILTER_STONES_MATERIAL,
        payload: {
          item,
          type
        }
      });
    })
    .then(() => dispatch(actions.setSearchTerm(search.term + " "))) //triggering a change to the search term forces the stone page to update
    .then(() => dispatch(actions.setSearchTerm(search.term))) //revert to previous term after triggering change
    .then(() => dispatch(actions.loadingDialog_show(false)));
  }
}

export function fetchStonesDefaultFilters(type) {
  return function (dispatch, getState) {
    const {get} = getApiConfig('Filters/GetStonesDefaultFilterGroups/' + type);
    dispatch({type: actionTypes.FETCHING_STONES_FILTERS});
    return get()
      .then((result) => {
        dispatch({
          type: actionTypes.FETCHED_STONES_FILTERS,
          payload: result
        })
      });
  }
}

export function deleteStone(stone, force = false) {
  return (dispatch, getState) => {
    const { search } = getState();
    const { post } = getApiConfig('Dashboard_Stones');

    dispatch(actions.loadingDialog_show(true, 'Checking Stone Usage...', 'Looking up stone usage, this will take just a moment.'))
      .then(() => post({
        stoneId: stone.id
      }, 'CheckStone'))
      .then(response => {
        let msg = "<div class='message-box-content-scrollable'>Are you sure you wish to delete this stone?<br />";
        if(response.stoneInUse) {
          msg += "This stone is currently in use by the following " + response.fabsUsingStone.length + " fabricator" + (response.fabsUsingStone.length == 1 ? "" : "s") + ":<br />";
          response.fabsUsingStone.sort();
          for(let i = 0; i < response.fabsUsingStone.length; i++) {
            let fab = response.fabsUsingStone[i];
            msg += fab + "<br />";
          }
        } else {
          msg += "This stone is not currently in use.<br />";
        }
        msg += "</div>";
        dispatch(actions.loadingDialog_show(false));
        dispatch(actions.messageBox_Show(true, 'system', 'Delete Stone?', msg, [
          {
            text: 'Yes',
            subtext: 'Delete the stone',
            onClick: () => {
              dispatch(actions.messageBox_Show()); //reset to default props (not visible by default)
              dispatch(actions.loadingDialog_show(true, 'Deleting Stone...', 'Deleting your stone. This will take just a moment.'));
              post({
                stoneId: stone.id
              }, "DeleteStone")
                .then(() => dispatch(actions.fetchStones()))
                .then(() => dispatch(actions.setSearchTerm(search.term + " "))) //triggering a change to the search term forces the stone page to update
                .then(() => dispatch(actions.setSearchTerm(search.term))) //revert to previous term after triggering change
                .then(() => dispatch(actions.loadingDialog_show(false)));
            }
          },
          {
            text: 'No',
            subtext: 'Do not delete the stone',
            onClick: () => dispatch(actions.messageBox_Show()) //reset to default props (not visible by default)
          }
        ]));
      });
  }
}

export function enableAllFabricatorStones(stones, enable = true) {
  let action = (enable ? 'Enabling' : 'Disabling');
  return function (dispatch, getState) {
    dispatch(actions.loadingDialog_show(true, `${action} all stones`, `Please wait, this can take a moment...`))
      .then(() => {
        const { editor, auth } = getState();
        if (!editor.name) {
          return dispatch({
            type: actionTypes.UPDATE_TRANSIENT_FIELD,
            payload: new Error('No editor is active'),
            error: true
          });
        } else {
          const editorName = editor.name;
          dispatch({
            type: actionTypes.UPDATE_TRANSIENT_FIELDS,
            payload: {
              editorName,
              fields: stones,
              key: 'enabled',
              value: enable,
              auth
            }
          });
        }
        return dispatch({
          type: actionTypes.STONE_SUPPLIER_STONE_UPDATE_STORE_VALUE,
          payload: {
            stones: _.map(stones, s => s.id),
            field: 'enabled',
            value: enable
          }
        });
      })
      .then(() => dispatch(actions.loadingDialog_show(false)));
  }
}

export { fetchStones, filterStonesColor, filterStonesMaterial, fetchStonesFilters, loadAndFetchStones };
